<template>
  <div>
    <ContentTitle>Summary</ContentTitle>
    <div v-if="totalInvoicePartialPaidCount > 0">
      <Icon iconStyle="fas" icon="fa-usd-circle" class="mr-1" /> {{totalInvoicePartialPaidCount}} Invoice{{totalInvoicePartialPaidCount | displayCountPlural}} have partial {{paymentsTitle}} made towards them
    </div>
    <div v-if="totalInvoiceFullPaidCount > 0">
      <Icon iconStyle="fas" icon="fa-check-circle" iconClass="result-fg-success" class="mr-1" /> {{totalInvoiceFullPaidCount}} Invoice{{totalInvoiceFullPaidCount | displayCountPlural}} have full {{paymentsTitle}} made and will be completed
    </div>
    <div v-if="totalOrderPartialPaidCount > 0">
      <Icon iconStyle="fas" icon="fa-usd-circle" class="mr-1" /> {{totalOrderPartialPaidCount}} Order{{totalOrderPartialPaidCount | displayCountPlural}} have partial {{paymentsTitle}} made towards them
    </div>
    <div v-if="totalOrderFullPaidCount > 0">
      <Icon iconStyle="fas" icon="fa-check-circle" iconClass="result-fg-success" class="mr-1" /> {{totalOrderFullPaidCount}} Order{{totalOrderFullPaidCount | displayCountPlural}} have full {{paymentsTitle}} made and will be progressed
    </div>
    <div v-if="totalOverpaymentValue > 0 && isPaymentMode && !isAllocationOnly">
      <Icon iconStyle="fas" icon="fa-exclamation-circle" iconClass="result-fg-notice" class="mr-1" /> There is an <strong>overpayment</strong> of <strong>{{totalOverpaymentValue | formatCurrency}}</strong> that will be allocated to the contact
    </div>
    <div v-if="totalOverpaymentValue > 0 && !isPaymentMode && !isAllocationOnly">
      <Icon iconStyle="fas" icon="fa-exclamation-circle" iconClass="result-fg-notice" class="mr-1" /> There is an <strong>unallocated</strong> amount of <strong>{{totalOverpaymentValue | formatCurrency}}</strong> that will be added in the credit note
    </div>
    <div v-if="totalInvoiceErrorCount > 0">
      <Icon iconStyle="fas" icon="fa-exclamation-circle" iconClass="result-fg-failed" class="mr-1" /> {{totalInvoiceErrorCount}} Invoice{{totalInvoiceErrorCount | displayCountPlural}} have payment <strong>errors</strong>
    </div>
    <div v-if="totalOrderErrorCount > 0">
      <Icon iconStyle="fas" icon="fa-exclamation-circle" iconClass="result-fg-failed" class="mr-1" /> {{totalOrderErrorCount}} Order{{totalOrderErrorCount | displayCountPlural}} have payment <strong>errors</strong>
    </div>
    <div v-if="currentPayment < totalAllocationAmount">
      <Icon iconStyle="fas" icon="fa-exclamation-circle" iconClass="result-fg-failed" class="mr-1" /> Amount is too low for the invoice / order allocations
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import Utils from '@/utils/utils'

export default {
  name: 'PaymentAllocationSummary',
  props: {
    invoiceAllocationList: Array,
    orderAllocationList: Array,
    isPaymentMode: Boolean,
    isAllocationOnly: Boolean,
    paymentAmount: Number
  },
  computed: {
    currentPayment() {
      return this.parseDecimal(this.paymentAmount)
    },
    paymentsTitle() {
      return this.isPaymentMode ? 'payments' : 'crediting'
    },
    totalInvoicePartialPaidCount() {
      return this.invoiceAllocationList.filter(invoice => this.parseDecimal(invoice.allocatedAmount) > 0 && this.parseDecimal(invoice.allocatedAmount) < invoice.amountDue).length
    },
    totalInvoiceFullPaidCount() {
      return this.invoiceAllocationList.filter(invoice => Utils.roundCurrency(this.parseDecimal(invoice.allocatedAmount) - invoice.amountDue) == 0).length
    },
    totalInvoiceErrorCount() {
      return this.invoiceAllocationList.filter(invoice => this.parseDecimal(invoice.allocatedAmount) > invoice.amountDue).length
    },
    totalInvoiceAllocation() {
      return this.invoiceAllocationList.reduce((curVal, invoice) => {
        return Utils.roundCurrency(curVal + this.parseDecimal(invoice.allocatedAmount))
      }, 0)
    },
    totalOrderPartialPaidCount() {
      return this.orderAllocationList.filter(order => this.parseDecimal(order.allocatedAmount) > 0 && this.parseDecimal(order.allocatedAmount) < order.amountDue).length
    },
    totalOrderFullPaidCount() {
      return this.orderAllocationList.filter(order => Utils.roundCurrency(this.parseDecimal(order.allocatedAmount) - order.amountDue) == 0).length
    },
    totalOrderErrorCount() {
      return this.orderAllocationList.filter(order => this.parseDecimal(order.allocatedAmount) > order.amountDue).length
    },
    totalOrderAllocation() {
      return this.orderAllocationList.reduce((curVal, order) => {
        return Utils.roundCurrency(curVal + this.parseDecimal(order.allocatedAmount))
      }, 0)
    },
    totalOverpaymentValue() {
      let overAmount = Utils.roundCurrency(this.currentPayment - this.totalInvoiceAllocation - this.totalOrderAllocation)
      return Math.max(overAmount, 0)
    },
    totalAllocationAmount() {
      return Utils.roundCurrency(this.totalInvoiceAllocation + this.totalOrderAllocation)
    }
  }
}
</script>